import axios from 'axios';

export const fetchLineProducts = (brandId: number) =>
  axios.get(`/api/line/brands/${brandId}/products`);

export const fetchLineProduct = (brandId: number, productId: number) =>
  axios.get(`/api/line/brands/${brandId}/products/${productId}`);

export const updateLineProduct = (
  brandId: number,
  productId: number,
  product: any
) =>
  axios.post(`/api/line/brands/${brandId}/products/${productId}`, {
    ...product,
  });

export const fetchLinePreorder = (brandId: number, productId: number) =>
  axios.get(`/api/line/brands/${brandId}/products/${productId}/preorder_dates`);

export const updateLinePreorder = (
  brandId: number,
  productId: number,
  order_created_at: string,
  delivery_at: string
) =>
  axios.post(
    `/api/line/brands/${brandId}/products/${productId}/preorder_dates`,
    {
      order_created_at,
      delivery_at,
    }
  );

export const deleteLinePreorder = (
  brandId: number,
  productId: number,
  preorderId: number
) =>
  axios.delete(
    `/api/line/brands/${brandId}/products/${productId}/preorder_dates/${preorderId}`
  );
